// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1Ma_E","buttons":"PendingPaymentAlert_buttons__2SqSy"};